"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PlayerGameWithRelsSchema = void 0;
const game_1 = require("./game");
const team_1 = require("./team");
exports.PlayerGameWithRelsSchema = game_1.GameWithRelsSchema.extend({
    team: team_1.TeamSchema,
});
//# sourceMappingURL=playerGame.js.map